import type { ReactElement } from 'react';
import { RelativeTimeWithTooltip } from '@/components/shared/RelativeTimeWithTooltip';
import { Badge } from '@/components/ui/badge';
import { AutoModeBadge } from '@/components/shared/AutoModeBadge';
import { autoModeToolTooltip } from '@/components/shared/autoModeTooltips';
import { isRecentlyDetected } from './recency';

interface InstalledToolCellRow {
  name: string;
  firstDetected: string | null;
  lastSeen: string | null;
  autoModeUserCount?: number;
}

export function NameCell({
  row,
}: {
  row: Pick<
    InstalledToolCellRow,
    'name' | 'firstDetected' | 'autoModeUserCount'
  >;
}): ReactElement {
  const isNew = isRecentlyDetected(row.firstDetected);
  return (
    <div className="flex items-center gap-2">
      <span className="text-sm">{row.name || '—'}</span>
      {isNew && (
        <Badge className="bg-blue-500 hover:bg-blue-600 text-xs px-1.5 py-0">
          NEW
        </Badge>
      )}
      {!!row.autoModeUserCount && (
        <AutoModeBadge tooltip={autoModeToolTooltip(row.autoModeUserCount)} />
      )}
    </div>
  );
}

export function FirstDetectedCell({
  row,
}: {
  row: Pick<InstalledToolCellRow, 'firstDetected'>;
}): ReactElement {
  if (!row.firstDetected) {
    return <span className="text-muted-foreground text-xs">—</span>;
  }
  return <RelativeTimeWithTooltip date={row.firstDetected} />;
}

export function LastSeenCell({
  row,
}: {
  row: Pick<InstalledToolCellRow, 'lastSeen'>;
}): ReactElement {
  if (!row.lastSeen) {
    return <span className="text-muted-foreground text-xs">—</span>;
  }
  return <RelativeTimeWithTooltip date={row.lastSeen} />;
}
